import Backbone from "backbone";
import rison from "rison";
import _ from "underscore";
import DriveView from "../../../../DriveView";
import HosSubMenu from "./../../subnavigation";
import constants, { HOURS } from "../../../../constants";
// eslint-disable-next-line max-len
import { getCurrentTimeWithUserTimezoneOffset, getStatusData, isValidOdometer, getMinEwdWorkMaximum, isExemptionAnnotationLengthValid, isBigDayExemptionButtonDisabled } from "../../../../utils/helpers";
import { dispatcher, DispatcherEvents } from "../../../../utils/dispatcher";
import { getCurrentVehicle, isNoVehicle, isSleeperBerthDisabled } from "../../../../utils/device";
import Sync from "../../../../sync/sync";
import { CancelablePromise as Promise } from "../../../../utils/cancelablePromise";
import {getServerDate, shiftDateTime} from "../../../../utils/storage/date";
import { getCurrentLocationUsingDeviceLocationAndGps } from "../../../../utils/location";
import HosProcess, { IHosProcessResult } from "../../../../services/hosProcess";
import dayjs from "../../../../utils/dayjs";
import { Dialog, offsetArrowUp } from "../../../framework/dialog";
import DutyStatusLog, { DISPLAY_STATUSES, IAnnotation } from "../../../../model/DutyStatusLog";
import { formatLocalDate, dstCalculator } from "../../../../utils/date";
import idSerializer from "geotab-uuid";
import { extend, jsonClone, htmlEscape } from "../../../../utils/vanilla";
import {
    type IHosAvailability,
    type IHosViolationSlim,
    type IMinAvailability,
    ALL_AUSTRALIAN_LOG_TYPES,
    offDutyStatuses,
    onDutyStatuses,
    convertToTimeString,
    type IViolation,
    timeSpanToMs,
    getMinEwdTimeUntilMustRest,
    getMinAvailability,
    getIconForAvailability,
    CANADARULESETS,
    roundBasedOnCurrentStatus,
    populateViolationReason,
    availToHours,
    getCurrentDay,
    MINUTES,
    isInCanada,
    type THosStatus,
    type THosOrigin,
    type IHosRuleset,
    type IEwdWorkRestAvailability,
    type IEwdRulesetWorkRestConfig
} from "hos-tools";
import { handleApi } from "../../../../utils/error";
// eslint-disable-next-line max-len
import { createFirstDayDialog, createBigDayDialog, createPersonalConveyanceStatusChangeDialog, createSituationDialog, createSecondDayDialog, createSplitSleeperEnableDialog, createSplitSleeperDisableDialog, TSituationActionType } from "./hosDialogs";
import { WorkdayType } from "../../../../store/data/types";
import { IWorkflowState } from "../../../workflow";
import { PageLevel } from "../../../../store/mobile/types";
import User from "../../../../model/User";
import { SyncType } from "../../../../sync/sync.types";
import toastr, { ToastOrigins, IToastLink } from "../../../../utils/toastr";
import { getCustomExemptHOSName } from "../../../../utils/hosHelpers";
import ButtonsBar, { IBarButton } from "../../../framework/buttonsBar";
import AvailabilityDisplay from "../../../framework/availabilityDisplay/availabilityDisplay";
import pageHTML from "./main.tmpl";
import situationDialogHTML from "./exemption.situationDialog.tmpl";
import { MobileActions } from "../../../../store/mobile/actions";
import StatusButtonDisplay, { StatusButtonDisplayOptions } from "../../../framework/statusButton/statusButtonDisplay";
import odometerDialogTemplate from "./odometerDialog.tmpl";
import adverseDrivingToolTipTemplate from "./exemption.adverseDrivingToolTip.tmpl";
import addressDialogTemplate from "../../../framework/addressDialog.tmpl";
import { FeatureFlagName } from "../../../../utils/featureFlagName";
import AutoCompletionInput from "../../../framework/autoCompletionInput";
import { HosDisplayPreferencesActions } from "../../../../modules/hos/store/actions";
import { getSplitSleeperEnabled } from "../../../../modules/hos/store/selectors";
import { getSplitSleeperAvailability, isSplitSleeperToggleAvailable } from "../../../../modules/hos/helpers/splitSleeperAvailability";

const rulesetsWithoutRecap: string[] = ["CarrierExemption", "CanadaOil", "CanadaNorthOf60Oil", "CanadaOilTeam", "CanadaNorthOf60OilTeam"];

export class HosMainModel extends Backbone.Model {
    workflow: boolean;
    hasNoVehicle = isNoVehicle();
    activeStatusCss: {[ status: string ]: string};
    disabledButtons: boolean;
    canEditUser: boolean;

    availabilityPercent = 100;
    violations: IViolation[] = [];
    cycleAvailableTomorrow = "";
    offDeferral: any = {};
    startOfDay = "";
    availabilityDisplayHtml: string;
    statusButtonDisplayHtml: string;

    inViolation = false;
    userRuleset: DeepReadonly<IHosRuleset>;
    rulesetKey: string;
    availability: IHosAvailability;
    ewdAvailability?: IEwdWorkRestAvailability[];

    minimumAvailability = "0:00";
    minimumAvailabilityText = "";
    iconClass = "";

    recapUi: { dateTime: string; duration: string }[] = [];
    recapTotal = "";
    recapInfo = false;

    noAvailabilityBar = false;
    hasAvailability = false;
    hasRecap = false;
    hasExemptions = false;
    showingExemptions = false;

    isActionRequired = false;
    actionMessage: string | null;
    workflowWarningMsg: string | null;
    workflowWarningType: "In violation" | "Upcoming violation" | "Violation risk" | null;
    canFixLastLog = false;

    currentSituationMessage = "";
    currentSituation: string | null;

    /* eslint-disable @typescript-eslint/naming-convention */
    Exemption16HValid: boolean | undefined = false;
    AdverseWeatherValid: boolean | undefined = false;
    isYMApplied: boolean | undefined = false;
    isPCApplied: boolean | undefined = false;
    isAdverseWeatherApplied: boolean | undefined = false;
    isEmergencyResponseExemptionApplied = false;
    OffDeferralValid: boolean | undefined = false;
    isSplittingWorkday: boolean | undefined = false;

    YMValid: boolean | null = false;
    PCValid: boolean | null = false;
    PC_ExemptedValid: boolean | null = false;
    WTValid: boolean | null = false;
    ExemptionReducedRestValid: boolean | null = false;
    RailroadExemptionValid = false;
    /* eslint-enable @typescript-eslint/naming-convention */

    isBigDayBonusAllowed = false;
    isBigDayExemptionButtonDisabled = false;
    isExemptionReducedRestAllowed = false;
    isADCAllowed = false;
    isYMAllowed = false;
    isPCAllowed = false;
    isExemptedHOSAllowed = false;
    isOilwellAllowed = false;
    isDeferralAllowed = false;
    isPCLimitExceeded = false;
    isRailroadExemptionAllowed = false;
    isEmergencyResponseExemptionAllowed = false;
    pcButtonText = "";
    //Default value for Exempted HOS
    customExemptHOSName = "Exempted HOS";
    customExemptHOSAbbreviation = "XEMP";
    maxPCDistance = "";
    maxPCDistanceString = "";
    personalConveyanceExceededString = "";

    isDriversSeatUser: boolean | null = false;
    ignoredLogMessage = "";

    // EWD STUFF
    isEwd = false;
    currentTime: string[]; // Hours, Minutes, Seconds
    isVerboseAvailability = true;
    approachingRest = false;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    WorkExemptionValid: boolean | null = false;
    hideRulesetChangeButton = false;
    pendingStatus = false;
    pendingStatusMessage = "";
    hasSplitSleeper = false;
    splitSleeperEnabled = false;
    splitSleeperLabel = "";
}

export default class HosView extends DriveView<HosMainModel> {
    protected strings = [
        "You are currently under the {0} exemption.",
        "Using PC while using Exempt HOS, {0}: {1}.",
        "personal conveyance",
        "yard move",
        "Oil well wait time",
        "{0} left",
        "Are you sure you want to apply the {0} exemption?",
        "Your duty status will be set to {0} for the duration of this exemption.",
        "personal conveyance",
        "yard move",
        "Press to continue or end your {0} status",
        "Day one",
        "Day two",
        "Off-duty deferred: {0}",
        "{0} days",
        "Adverse driving conditions",
        "Adverse driving conditions applied at {0}",
        "You can drive your truck off-duty when relieved from work duties.",
        "Note: Your PC Status doesn't end when the ignition is off. When you restart the vehicle, you must continue or end the status, or your status will switch to driving.",
        "This relieves you from driving hour rules for today. It ends automatically with your workday, or you may end it earlier.",
        "Wait time applied at {0}.",
        "The number of times the 16-hour exemption can be used: {0}. This can be used every {1} days and is not extended by split sleeper breaks.",
        "16-hour exemption applied at {0}.",
        "{0} is now {1}",
        "{0} is now {1} at {2}.",
        "Driving",
        "in Sleeper Berth",
        "On Duty",
        "Off Duty",
        "Currently working",
        "Currently resting",
        "Change time or annotate",
        "Continue",
        "Start day",
        "End day",
        "The maximum daily personal conveyance limit is {0}.",
        "Maximum daily personal conveyance limit of {0} exceeded.",
        "Work Exemption",
        "A log with status {0} already exists at {1}. Please wait until the current log has elapsed at least 15 minutes to enter {2}.",
        "A log with status {0} already exists at {1}. Please wait until the future log has elapsed at least 15 minutes to enter {2}.",
        "A log with status {0} already exists at {1}. Please wait until the future log is active to enter {2}.",
        "h",
        "{minutes}m",
        "Split sleeper display",
        "Excludes {0} ignored logs ({time}) which will still appear on Roadside Checks.",
        "Railroad exemption applied at {0}.",
        "Exemption applied",
        "This exemption applies to weather hazards (snow, ice, sleet, fog, or other bad weather) and unusual road conditions. These conditions were unforeseeable at the start of your shift, after your last break, or to your carrier before dispatch.",
        "{Work status} will begin at {date}. You cannot change status again until {Shift date}.",
        "Alberta Reduced Rest",
        "Apply during or after the period of reduced rest. You can use this exemption once every 7 days. Exemption not available while in violation.",
        "Add any reduction in rest to your next shift reset.",
        "Number of additional off-duty hours you are required to take for your next shift reset: {0}",
        "{0} Break duration",
        "{0} Break",
        "{0} Break required in",
        "Exemption ended",
        "Enabled",
        "Disabled",
        "Are you sure you want to end the exemption? Any further driving will create {0} status records.",
        "An annotation is required:",
        "Enter reason for exemption:",
        "Please describe the reason:",
        "This exemption extends your available hours through the rest of the day. The system won't record violations while it's active.",
        "The exemption ends automatically at the end of your day. You can end it earlier.",
        "Reason for exemption (such as a job or dispatch number)",
        "Your available hours will return to normal immediately. You may already be out of hours.",
        "OFF",
        "SB",
        "D",
        "ON"
    ];

    private readonly template = _.template(pageHTML);
    private readonly odometerInputDialogTemplate = _.template(odometerDialogTemplate);
    private readonly adverseDrivingToolTipTemplate = _.template(adverseDrivingToolTipTemplate);
    private readonly sync: Sync;
    private readonly hosUtils: HosProcess;
    private readonly menu: HosSubMenu;
    private readonly newLogId?: string;
    private readonly availabilityDisplay: AvailabilityDisplay;
    private readonly statusButtonDisplay: StatusButtonDisplay;
    private buttonsBar: ButtonsBar | undefined;
    private currentUser: IUser;
    private ruleResult: IHosProcessResult | undefined = undefined;
    private statusChangeTimeout: any = null;
    private newStatusChange: THosStatus | undefined;
    private dateTimeForNewLog: string | undefined;
    private latestLog: DutyStatusLog | null = null;
    private isAutoEndingPC = false;
    private cachedLogs: DutyStatusLog[] = this.app.dutyStatusLogService.getSortedHosLogs(this.app.dutyStatusLogService.getHOSLogs(false).filter(hosLog => hosLog.isStandardStatusDriverLog()));
    private readonly isEwd: boolean;
    private readonly onResizeBind;
    private toolTip: Dialog;
    private autoCompletionInput?: AutoCompletionInput;

    constructor(options) {
        super(options, {
            title: options.title || "HOS",
            activeSection: "hos",
            activeView: "status",
            pageLevel: options.pageLevel || PageLevel.ONE
        });
        this.availabilityDisplay = new AvailabilityDisplay();
        this.statusButtonDisplay = new StatusButtonDisplay();

        this.model = new HosMainModel();
        this.model.workflow = options.workflow || false;
        this.newLogId = options.newLogId;

        this.sync = this.app.sync;
        this.hosUtils = this.app.hosUtils;
        this.currentUser = this.app.userService.getCurrentUser() as IUser;
        this.isEwd = this.app.store.getState().data.ELDJurisdiction === "EWD";

        if (!this.model.workflow) {
            this.menu = new HosSubMenu({ app: this.app, active: "status" });
        }

        this.latestLog = this.app.dutyStatusLogService.getLatestLog(this.cachedLogs);
        let status = this.latestLog ? this.latestLog.status : undefined;
        if (status === "YM" || status === "PC" || status === "PC_Exempted" || status === "INT_PC" || status === "WT") {
            // If using exemption, open exemptions window by default
            this.model.showingExemptions = true;
        }

        this.ruleResult = this.hosUtils.process();
        this.listenTo(dispatcher, `${ DispatcherEvents.SyncUserHosRuleSet } ${ DispatcherEvents.UserUpdate }`, this.onUserUpdateOrRulesetSync.bind(this));
        this.listenTo(dispatcher, DispatcherEvents.HosRuleCompute, this.ruleCompute.bind(this));
        this.listenTo(dispatcher, DispatcherEvents.SyncComplete, () => {
            this.cachedLogs = this.app.dutyStatusLogService.getHOSLogs().filter(hosLog => hosLog.isStandardStatusDriverLog());
            let latestLog = this.app.dutyStatusLogService.getLatestLog(this.cachedLogs);
            latestLog && this.setLatestLog(latestLog);
            this.hosUtils.process();
        });
        this.listenTo(dispatcher, DispatcherEvents.UIUserMenu, this.userMenuOpened.bind(this));
        this.listenTo(dispatcher, DispatcherEvents.DriverSwitch, this.render.bind(this));
        this.listenTo(dispatcher, DispatcherEvents.VehicleSelected, this.render.bind(this));

        this.onResizeBind = this.onResize.bind(this);
        window.addEventListener("resize", this.onResizeBind);
    }

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            // MYG-41735
            //"click #verboseDisplay": this.toggleVerboseDisplay,
            "click .hos-status-button": this.initiateChangeDutyStatus,
            "click .ewd-status-button": this.initiateChangeDutyStatus,
            "click #workExempt": this.applyWorkExemption,
            "click #violationWarning": this.navigateLogList,
            "click #recapInfo": this.availMoreInfo,
            "click #exemptions": this.availMoreInfo,
            "click #applyBigDay": this.applyBigDay,
            "click #applyAdverseWeather": this.applyAdverseWeather,
            "click #removeAdverseWeather": this.removeAdverseWeather,
            "click #offDeferral": this.applyOffDeferral,
            "click #yardMove": this.applyYardMove,
            "click #removeYardMove": this.applyYardMove,
            "click #personalConveyance": this.applyPersonalConveyance,
            "click #removePersonalConveyance": this.applyPersonalConveyance,
            "click #exemptedHOS": this.applyExemptedHOS,
            "click #waitTime": this.applyWaitTime,
            "click #applyReducedRest": this.applyReducedRest,
            "click #actionRequired": this.applyAction,
            "click #changeRuleset": this.changeRuleset,
            "click #workflowWarning": this.fixLastLog,
            "click #railroadExempt": this.applyRailroadExemption,
            "click #startEmergencyResponseExemption": this.startEmergencyResponseExemption,
            "click #endEmergencyResponseExemption": this.endEmergencyResponseExemption,
            "click #adverseDriving-toolTip": this.openToolTip,
            "click .availability-toolTip": this.openAvailabilityToolTip,
            "change #splitSleeperToggle": this.onSplitSleeperToggled
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    // MYG-41735
    // toggleVerboseDisplay() {
    //     this.model.isVerboseAvailability = !this.model.isVerboseAvailability;
    //     this.renderImpl();
    // }

    changeRuleset() {
        this.app.router.navigate("/framework/ruleSetChangeView", true);
    }

    onSplitSleeperToggled(e: Event) {
        const checkbox = e.currentTarget as HTMLInputElement;
        const isEnabled = checkbox.checked;

        // Leave the checkbox in the state the browser just put it in. We only flip
        // it back if the driver cancels the confirmation dialog. Flipping the DOM
        // state inside the change handler races with the browser's own state and
        // causes the toggle to appear "stuck" requiring a second tap.

        if (isEnabled) {
            createSplitSleeperEnableDialog(
                this.app.store,
                () => { this.applySplitSleeperToggle(true); },
                () => { checkbox.checked = false; },
                this.translator
            );
        } else {
            createSplitSleeperDisableDialog(
                this.app.store,
                () => { this.applySplitSleeperToggle(false); },
                () => { checkbox.checked = true; },
                this.translator
            );
        }
    }

    unsetLatestLog(oldLog: DutyStatusLog | null = null, render = false) {
        this.latestLog = oldLog || this.app.dutyStatusLogService.getLatestLog(this.cachedLogs);
        render && this.renderImpl();
    }

    setLatestLog(newLog: DutyStatusLog) {
        if (!(newLog && newLog.isNormalLog())) {
            return;
        }

        if (!this.latestLog) {
            this.latestLog = newLog;
        } else {
            if (this.latestLog.id === newLog.id) {
                if (!this.latestLog.version && newLog.version) {
                    this.latestLog = newLog;
                }
            } else if (this.latestLog.getDate() < newLog.getDate() || (this.latestLog.version && !this.app.dutyStatusLogService.getLogById(this.cachedLogs, this.latestLog.id))) {
                this.latestLog = newLog;
            }
        }
    }

    render() {
        this.model.workflow && this.createButtonsBar();
        const store = this.app.store;
        const pageState = store.getState().mobile.pageState;
        if (pageState?.title === "HOS" && store.getState().data.ELDJurisdiction === "EWD") {
            store.dispatch(MobileActions.setPageState({
                ...pageState,
                ...{ title: "Work Diary" }
            }));
        }
        this.renderImpl();
        return this;
    }

    isPCIgnitionOffDuringPC(status, logdate: Date | null) {
        let engineLogs = this.app.dutyStatusLogService.getHOSLogs(true, undefined, false, true).filter(log => log.isEngineLog());
        let latestEngineLog = engineLogs.length > 0 ? engineLogs[engineLogs.length - 1] : null;

        if (latestEngineLog && logdate) {
            let isIgnitionOff = latestEngineLog.status === "EngineShutdownPC";
            let isPC = status === "PC" || status === "INT_PC";

            // For this to be correct, the engine log should be after the last PC log
            return isIgnitionOff && isPC && latestEngineLog.getDate() > logdate;
        }

        return false;
    }

    isPCActionRequired(status, logdate: Date | null) {
        if (!this.model.isPCAllowed) {
            return false;
        }

        return this.isPCIgnitionOffDuringPC(status, logdate);
    }

    // eslint-disable-next-line complexity
    renderImpl(adjustPage = false) {
        let isEwd = this.app.store.getState().data.ELDJurisdiction === "EWD";

        if (isEwd){
            let formatTime = (currentDate: Date) => {
                let hours = currentDate.getHours();
                let minutes = currentDate.getMinutes();
                let seconds = currentDate.getSeconds();

                return [
                    hours <= 9 ? `0${ hours }` : `${ hours }`,
                    minutes <= 9 ? `0${ minutes }` : `${ minutes }`,
                    seconds <= 9 ? `0${ seconds }` : `${ seconds }`
                ];
            };

            this.app.store.dispatch(MobileActions.setPageState({
                title: "Work Diary",
                pageLevel: PageLevel.ONE
            }));

            this.model.isEwd = true;
            this.model.currentTime = formatTime(getCurrentTimeWithUserTimezoneOffset());

            // The ruleset change button is hidden in EWD mode (for now), but show it if we're in debug mode.
            this.model.hideRulesetChangeButton = !this.app.store.getState().data.debugMode;
        }

        let status: THosStatus | undefined = isEwd ? this.getCurrentLog()?.status : this.latestLog?.status;

        this.model.pendingStatus = isEwd && status !== this.latestLog?.status;
        let latestLogDate = this.latestLog?.getDate();
        if (this.model.pendingStatus && latestLogDate) {
            let localDate = dstCalculator.toLocalDateTime(latestLogDate);
            let localDateString = localDate.toLocaleString("en-au", { hour12: false, hour: "2-digit", minute: "2-digit" }).replace("24", "00");
            let fifteenMinutesFromPendingStatus = shiftDateTime(localDate, 1000 * 60 * 15);
            let fifteenMinutesFromPendingStatusString = fifteenMinutesFromPendingStatus?.toLocaleString("en-au", { hour12: false, hour: "2-digit", minute: "2-digit" }).replace("24", "00");
            this.model.pendingStatusMessage = this.getString("{Work status} will begin at {date}. You cannot change status again until {Shift date}.")
                .replace("{Work status}", this.latestLog?.status as string)
                .replace("{date}", localDateString)
                .replace("{Shift date}", fifteenMinutesFromPendingStatusString);
        }
        let currentSituation = this.app.dutyStatusLogService.getCurrentSituationDescription(status, this.cachedLogs);
        let ruleSetKey = this.hosUtils.getValidRuleSet(this.hosUtils.getLatestHosRuleSetIdShortened(true));
        let ruleset = this.hosUtils.getRuleSets()[ruleSetKey];

        this.model.isDriversSeatUser = this.isDriversSeatUser();
        this.model.userRuleset = ruleset;
        this.model.rulesetKey = ruleSetKey;
        this.model.availability = this.hosUtils.getDefaultAvailability(ruleSetKey);
        this.model.hasNoVehicle = isNoVehicle();

        this.model.currentSituation = currentSituation;
        this.model.disabledButtons = status === "YM" || status === "PC" || status === "PC_Exempted" || status === "INT_PC" || status === "WT" || status === "WorkExemption";
        this.model.activeStatusCss = {};
        if (status) {
            this.model.activeStatusCss[status] = `${ isEwd ? "ewd-status-button_active" : "hos-status-button_active" } current-status`;
        }

        const isSplitSleeperToggleFlagEnabled = this.app.featureFlagService.hasFeatureFlag(FeatureFlagName.ENABLE_SPLIT_SLEEPER_TOGGLE);
        this.model.hasSplitSleeper = isSplitSleeperToggleAvailable(isSplitSleeperToggleFlagEnabled, ruleset);
        this.model.splitSleeperEnabled = this.model.hasSplitSleeper
            ? getSplitSleeperEnabled(this.app.store.getState().hosDisplayPreferences, this.currentUser?.id)
            : false;

        if (this.ruleResult) {
            this.renderRuleResult(this.ruleResult);

            let ignoredLogCountAndDurationInCurrentCycle = this.hosUtils.getIgnoredLogCountAndDurationInCurrentCycle();
            if (ignoredLogCountAndDurationInCurrentCycle) {
                this.model.ignoredLogMessage = this.getString("Excludes {0} ignored logs ({time}) which will still appear on Roadside Checks.")
                                        .replace("{0}", ignoredLogCountAndDurationInCurrentCycle.count.toString())
                                        .replace("{time}", ignoredLogCountAndDurationInCurrentCycle.duration);
            }
        }

        this.model.startOfDay = this.hosUtils.formatStartOfDay(this.hosUtils.getLatestHosRuleSet()) || "";

        this.calculateAvailability();
        let availabilityKeys = Object.keys(this.model.availability);
        this.model.hasAvailability = isEwd ? true : this.hosUtils.hasAvailability(ruleSetKey);
        this.model.hasRecap = availabilityKeys.indexOf("recap") > -1 && rulesetsWithoutRecap.indexOf(this.model.rulesetKey) === -1;
        this.model.noAvailabilityBar = this.hosUtils.noAvailabilityBar(ruleset);
        this.model.splitSleeperLabel = this.getString("Split sleeper display");

        if (currentSituation !== null) {
            if (status === "PC_Exempted") {
                this.model.currentSituationMessage = this.getString(this.strings[0]).replace("{0}", getCustomExemptHOSName(this.app.store.getState().systemSettings));
            } else {
                this.model.currentSituationMessage = this.getString(this.strings[0]).replace("{0}", this.getString(currentSituation));
            }
        }

        let isPcExemptValid = this.model.PC_ExemptedValid;
        this.validateExemptions(ruleset, ruleSetKey);

        let logDate = this.latestLog ? this.latestLog.getDate() : null;
        this.model.isActionRequired = this.isPCActionRequired(status, logDate);
        if (this.model.isActionRequired) {
            this.model.actionMessage = this.getString("Press to continue or end your {0} status").replace("{0}", this.getString("personal conveyance"));
        } else if (!this.isAutoEndingPC && this.isPCIgnitionOffDuringPC(status, logDate) && !this.model.isPCAllowed) {
            // PC access was revoked while driver was in PC — auto-end PC session
            this.isAutoEndingPC = true;
            this.changeExemptionStatus("OFF", undefined, true, false, [], this.latestLog?.device as IIdEntity, "OtherUser")
                .then(() => { this.isAutoEndingPC = false; })
                .catch(error => {
                    this.isAutoEndingPC = false;
                    handleApi(error);
                });
            return;
        }

        if (this.model.minimumAvailability !== "") {
            this.model.minimumAvailabilityText = this.getString("{0} left").replace("{0}", this.model.minimumAvailability);
        }
        if (this.model.maxPCDistance !== "") {
            if (this.model.isPCLimitExceeded) {
                this.model.personalConveyanceExceededString = this.getString("Maximum daily personal conveyance limit of {0} exceeded.").replace("{0}", this.model.maxPCDistance);
            } else {
                this.model.maxPCDistanceString = this.getString("The maximum daily personal conveyance limit is {0}.").replace("{0}", this.model.maxPCDistance);
            }
        }
        if (this.model.workflow && isPcExemptValid !== this.model.PC_ExemptedValid) {
            this.createButtonsBar();
        }

        if (this.model.availability.recap) {
            this.addRecap();
        }

        this.model.canEditUser = this.app.securityService.can("editUser");

        this.app.localizerService.initUserUnits(this.translator)
            .then(() => this.getAvailabilityWarnings(this.latestLog))
            .then(() => {
                let availabilityHtml = "";
                if (this.model.hasAvailability && this.ruleResult) {
                    let restConfig = ruleset?.config?.rest;
                    let breakMinutes = restConfig?.restBreakMinimum ? restConfig.restBreakMinimum / MINUTES : 0;
                    let betweenRestHours = restConfig?.betweenRestLimit ? restConfig.betweenRestLimit / HOURS : 0;
                    let breakTooltip = breakMinutes && betweenRestHours
                        ? this.getString("Your time in Off Duty or Sleeper Berth. A minimum {x}-minute break is required after every {y}-hour driving or on-duty period.")
                            .replace("{x}", String(breakMinutes))
                            .replace("{y}", String(betweenRestHours))
                        : "";
                    this.availabilityDisplay.setTooltips({
                        "cycleRestDuration": this.getString("This timer starts when you log Off Duty or Sleeper Berth.") + "<br><br>" + this.getString("Note: Unassign from the vehicle before you rest. This stops other drivers from affecting your logs."),
                        "drivingBreakDuration": breakTooltip,
                        "rest": this.getString("This is your driving time left before your required break. The timer resets after a full break.")
                    });
                    availabilityHtml = this.availabilityDisplay.getDisplay(
                        this.engineResultToDisplay(this.ruleResult),
                        ruleSetKey,
                        isEwd ? this.getCurrentLog() : this.latestLog,
                        this.getString("{0} days"),
                        isEwd ? "EWD" : "HOS",
                        getCurrentTimeWithUserTimezoneOffset(),
                        this.model.isVerboseAvailability,
                        this.getString("h"),
                        this.getString("{minutes}m").replace("{minutes}", ""),
                        this.getString("{0} Break duration"),
                        this.getString("{0} Break"),
                        this.getString("{0} Break required in")
                    );
                }
                this.model.availabilityDisplayHtml = availabilityHtml;
            })
            .then(() => {
                let displayOptions: StatusButtonDisplayOptions = {
                    mode: isEwd ? "EWD" : "HOS",
                    activeStatusCss: this.model.activeStatusCss,
                    disabledButtons: this.model.disabledButtons,
                    isSleeperBerthDisabled: isSleeperBerthDisabled(this.app.store),
                    isDriversSeatUser: this.model.isDriversSeatUser,
                    hasNoVehicle: this.model.hasNoVehicle,
                    status: status,
                    translatedLabels: {
                        off: this.getString("OFF"),
                        sb: this.getString("SB"),
                        d: this.getString("D"),
                        on: this.getString("ON")
                    }
                };
                this.model.statusButtonDisplayHtml = this.statusButtonDisplay.getDisplay(displayOptions);
                return this.display(this.template(this.model));
            })
            .then(() => {
                this.menu && this.menu.render();
                this.buttonsBar && this.buttonsBar.show();
                if (adjustPage) {
                    let newDiv = <HTMLButtonElement>document.querySelector("div.hos-status-dashboard__cycle-extra-panel");
                    if (newDiv) {
                        newDiv.scrollIntoView();
                    }
                }
            })
            .catch(handleApi);
    }

    addRecap() {
        this.model.recapUi = [];
        let recapTotal = 0;
        let today = dstCalculator.toLocalDateTime(getServerDate()).getDate();

        if (this.model.availability) {
            for (let recap of this.model.availability.recap) {
                let hours = timeSpanToMs(recap.duration) / 1000 / 60 / 60;
                recapTotal += hours;

                let localUserTime = dstCalculator.toLocalDateTime(recap.dateTime);

                this.model.recapUi.push({
                    dateTime: localUserTime.getDate() === today ? "Today" : dayjs(localUserTime).format("ll"),
                    duration: this.convertMsToString(hours)
                });
            }
        }

        this.model.recapTotal = this.convertMsToString(recapTotal);
    }

    calculateAvailability() {
        if (Object.keys(this.model.availability).length > 0) {
            let minAvail: IMinAvailability = this.isEwd ? getMinEwdTimeUntilMustRest(this.model.ewdAvailability || []) : getMinAvailability(this.model.availability);
            let minimumAvailability = minAvail.min;
            let defaultMin = 0;

            this.model.iconClass = this.isEwd ? "drive-clock" : getIconForAvailability(minAvail.name || "");

            if (this.isEwd) {
                let userRuleSetLabel = this.hosUtils.getValidRuleSet(this.hosUtils.getLatestHosRuleSetIdShortened(true));
                let rulesetConf = this.hosUtils.getRuleSets()[userRuleSetLabel].config.workRestConfig as IEwdRulesetWorkRestConfig[];
                defaultMin = getMinEwdWorkMaximum(rulesetConf);
            } else {
                let defaultAvail = this.hosUtils.getDefaultAvailability(this.hosUtils.getLatestHosRuleSetIdShortened(true));
                defaultMin = getMinAvailability(defaultAvail).min;
            }

            if (minimumAvailability === Infinity) {
                minimumAvailability = 0;
            }

            if (!defaultMin || defaultMin === Infinity) {
                defaultMin = 8;
            }
            let minimumPercent: any = (minimumAvailability / defaultMin) * 100;
            this.model.availabilityPercent = typeof minimumPercent === "number" ? Number(Math.min(minimumPercent, 100).toFixed(1)) : 100;
            this.model.minimumAvailability = this.convertMsToString(minimumAvailability) || `0${ this.getString("{minutes}m").replace("{minutes}", "") }`;
        } else {
            this.model.availabilityPercent = 0;
            this.model.minimumAvailability = "";
        }

        let cycleTomorrow = this.convertMsToString(this.model.availability.cycleAvailabilities && availToHours(this.model.availability.cycleAvailabilities[0].available) || 0);
        this.model.cycleAvailableTomorrow = cycleTomorrow;
    }

    validateExemptionsBasedOnCurrentStatus(ruleSetKey: string) {
        let isDriverWithVehicle = this.isDriversSeatUser() && !this.model.hasNoVehicle;
        let status = this.latestLog ? this.latestLog.status : undefined;

        // The ability for the user to select this option given it is being used, not if the user can use it
        switch (status) {
            case "YM":
                this.model.isYMApplied = true;
                this.model.YMValid = null;
                this.model.PCValid = false;
                this.model.WTValid = false;
                this.model.PC_ExemptedValid = false;
                break;
            case "PC_Exempted":
                this.model.isPCApplied = true;
                this.model.YMValid = false;
                this.model.PCValid = false;
                this.model.WTValid = false;
                this.model.PC_ExemptedValid = null;
                break;
            case "PC":
            case "INT_PC":
                this.model.isPCApplied = true;
                this.model.YMValid = false;
                this.model.PCValid = null;
                this.model.WTValid = false;
                this.model.PC_ExemptedValid = false;
                break;
            case "WT":
                this.model.YMValid = false;
                this.model.PCValid = false;
                this.model.WTValid = null;
                this.model.PC_ExemptedValid = false;
                break;
            case "Rest":
                this.model.WorkExemptionValid = false;
                break;
            case "WorkExemption":
                this.model.WorkExemptionValid = null;
                break;
            default:
                this.model.isYMApplied = false;
                this.model.isPCApplied = false;
                this.model.YMValid = this.isValidExemption(ruleSetKey, isDriverWithVehicle);
                this.model.PCValid = this.isValidExemption(ruleSetKey, isDriverWithVehicle);
                this.model.WTValid = true;
                this.model.PC_ExemptedValid = true && isDriverWithVehicle;
                this.model.WorkExemptionValid = true;
                break;
        }
    }

    validateExemptions(ruleset: DeepReadonlyObject<IHosRuleset>, ruleSetKey: string) {
        this.validateExemptionsBasedOnCurrentStatus(ruleSetKey);

        this.model.isEmergencyResponseExemptionAllowed = this.app.featureFlagService.hasFeatureFlag(FeatureFlagName.ENABLE_EMERGENCY_RESPONSE_EXEMPTION)
            && this.currentUser.isEmergencyResponseExemptionAllowed === true;
        this.model.hasExemptions = this.hosUtils.canUseExemptions(this.currentUser, ruleset, ruleSetKey) || this.model.isEmergencyResponseExemptionAllowed;
        this.model.isBigDayBonusAllowed = !!ruleset.config.bigDayBonus;
        this.model.isExemptionReducedRestAllowed = !!ruleset.config.workday?.exemptionReducedRest;
        this.model.isOilwellAllowed = !!ruleset.config.oilwell;
        this.model.isRailroadExemptionAllowed = !!ruleset.config.railroadExempt;
        // TODO MYG-32195: Include value (true) for deferralAllowed property into ruleset config for these rulesets:
        // "CanadaCycleOne", "CanadaCycleTwo", "CanadaCycleOneTeam", "CanadaCycleTwoTeam".
        // It will require to create a new Upgrade script to modify existing records in db.
        this.model.isDeferralAllowed = !!ruleset.config.daily?.deferralAllowed || this.isDeferralAllowed(ruleSetKey);
        this.model.isYMAllowed = this.currentUser.isYardMoveEnabled || false;
        this.model.isExemptedHOSAllowed = this.currentUser.isExemptHOSEnabled || false;
        this.model.isPCAllowed = this.currentUser.isPersonalConveyanceEnabled || false;
        this.model.isADCAllowed = this.currentUser.isAdverseDrivingEnabled === undefined ? true : this.currentUser.isAdverseDrivingEnabled;

        if (this.model.isEwd) {
            this.model.WorkExemptionValid = this.model.WorkExemptionValid && ruleset.config.exempt === true;
        }

        let systemSettings = this.app.store.getState().systemSettings;

        if (systemSettings) {
            this.model.customExemptHOSName = htmlEscape(systemSettings.customExemptHOSName);
        }

        if (this.model.isPCAllowed) {
            let sysMaxPCLimit = systemSettings && systemSettings.maxPCDistance ? Number(systemSettings.maxPCDistance) : -1;
            let reachedDailyPCDrivingLimit = this.app.dutyStatusLogService.reachedDailyPCDrivingLimit(this.currentUser.id);
            this.model.isPCLimitExceeded = reachedDailyPCDrivingLimit.reachedLimit;
            this.updatePCButtonState();
            this.setMaxPCDistancePerDay(ruleSetKey, this.currentUser, sysMaxPCLimit, this.model);
        } else {
            this.model.isPCLimitExceeded = false;
            this.model.pcButtonText = "Disabled";
        }

        if (this.ruleResult) {
            this.model.OffDeferralValid = this.ruleResult.availability.isOffDutyDeferralExemptionAvailable === true;
            this.model.Exemption16HValid = this.ruleResult.availability.is16HourExemptionAvailable === true;
            this.model.AdverseWeatherValid = this.ruleResult.availability.isAdverseDrivingExemptionAvailable;
            this.model.isAdverseWeatherApplied = this.ruleResult.availability.isAdverseDrivingApplied;
            this.model.RailroadExemptionValid = this.ruleResult.availability.isRailroadExemptionAvailable === true;
            this.model.isEmergencyResponseExemptionApplied = this.ruleResult.availability.isEmergencyResponseExemptionApplied === true;
            this.model.ExemptionReducedRestValid = this.ruleResult.availability.exemptionReducedRest?.isAvailable === true;
            this.model.isSplittingWorkday = this.app.featureFlagService.hasFeatureFlag(FeatureFlagName.ENABLE_SPLIT_BLOCKS_DEFERRAL) && this.ruleResult.availability.isSplittingWorkday === true;
        }

        this.model.isBigDayExemptionButtonDisabled = isBigDayExemptionButtonDisabled(
            this.model.Exemption16HValid,
            this.model.isAdverseWeatherApplied,
            this.app.featureFlagService.hasFeatureFlag(FeatureFlagName.DISABLE_EXEMPTION_LOGS_INTERACTION_REFACTOR)
        );
    }

    updatePCButtonState() {
        let status = this.latestLog ? this.latestLog.status : undefined;
        if (status === "PC" || status === "INT_PC") {
            this.model.pcButtonText = "Stop";
        } else {
            this.model.pcButtonText = "Start";
        }
    }

    setMaxPCDistancePerDay
    (
        ruleSetKey: string,
        user: DeepReadonly<IUser>,
        maxPCDistance: number,
        model?: HosMainModel
    ): void {
        let userPCLimitInMeters = user?.maxPCDistancePerDay !== undefined && user?.maxPCDistancePerDay >= 0
            ? user.maxPCDistancePerDay
            : maxPCDistance;

        if (CANADARULESETS.some((ruleSet) => ruleSet.indexOf(ruleSetKey) > -1)) {
            if (userPCLimitInMeters > constants.CANADA_MAX_PC_LIMIT || userPCLimitInMeters <= 0) {
                userPCLimitInMeters = constants.CANADA_MAX_PC_LIMIT;
            }
        }
        if (model) {
            if (user?.isMetric && userPCLimitInMeters > 0) {
                model.maxPCDistance = (userPCLimitInMeters / 1000).toFixed(1) + " km";
            } else if (!user?.isMetric && userPCLimitInMeters > 0) {
                model.maxPCDistance = (userPCLimitInMeters / 1609).toFixed(1) + " mi";
            }
        }
    }

    isDeferralAllowed(ruleSetKey: string): boolean {
        return ruleSetKey === "CanadaCycleOne"
            || ruleSetKey === "CanadaCycleTwo"
            || ruleSetKey === "CanadaCycleOneTeam"
            || ruleSetKey === "CanadaCycleTwoTeam";
    }

    getWorkdayToastLink(status: THosStatus): IToastLink[] {
        let user = this.currentUser;
        if (!user || !this.app.securityService.can("viewDriverClockInOut")) {
            return [];
        }

        let workday = this.app.store.getState().data.workday[user.id];

        if ((status === "ON" || status === "D") && workday === WorkdayType.Stopped) {
            return [{
                linkText: this.getString("Start day"),
                linkId: "button-workday-on",
                linkCallback: () => {
                    let nextPageState: IWorkflowState = {};
                    let driver = this.app.userService.getDriversSeatUser();
                    if (driver && driver.id !== this.currentUser.id) {
                        nextPageState = { coDriver: true };
                    }
                    this.app.router.toWorkflow(false, nextPageState);
                }
            }];
        }

        if ((status === "OFF" || status === "SB") && workday === WorkdayType.Started) {
            return [{
                linkText: this.getString("End day"),
                linkId: "button-workday-off",
                linkCallback: () => this.app.router.toWorkflow(true)
            }];
        }

        return [];
    }

    initiateChangeDutyStatus(e) {
        let button = <HTMLElement>e.currentTarget;
        if (button.classList.contains("button_disabled")) {
            return;
        }

        this.newStatusChange = button.getAttribute("data-status") as THosStatus;
        this.setActiveStatusButton(this.newStatusChange);

        let isSameStatusAsBefore = this.latestLog && this.latestLog.status && this.latestLog.status === this.newStatusChange && !this.isEwd;
        if (isSameStatusAsBefore || ((this.newStatusChange === "D" || this.newStatusChange === "SB") && this.model.hasNoVehicle)) {
            this.newStatusChange = undefined;
            return;
        }

        if (this.isEwd) {
            let previousLog = this.isEwd ? this.getCurrentLog() : this.latestLog;
            let currentStatus = previousLog && previousLog.status || undefined;
            let ewdDateTime = roundBasedOnCurrentStatus(getServerDate(), this.newStatusChange, currentStatus);
            let message = "";
            let isNewLogBeforePreviousLog = previousLog && new Date(previousLog.dateTime) > ewdDateTime;
            let logWithSameDateTime = this.app.dutyStatusLogService.getLogWithIdenticalDateTime(new Date(ewdDateTime.toISOString()));

            if (isNewLogBeforePreviousLog && previousLog && ["Work", "Rest", "WorkExemption"].indexOf(previousLog.status) !== -1) {
                message = this.getString("A log with status {0} already exists at {1}. Please wait until the future log has elapsed at least 15 minutes to enter {2}.")
                            .replace("{0}", previousLog.status)
                            .replace("{1}", this.convertUtcDateToUserLocal(new Date(previousLog.dateTime)))
                            .replace("{2}", this.newStatusChange);
            } else if (logWithSameDateTime) {
                if (this.newStatusChange === "Rest") {
                    message = this.getString("A log with status {0} already exists at {1}. Please wait until the future log is active to enter {2}.")
                            .replace("{0}", logWithSameDateTime.status)
                            .replace("{1}", this.convertUtcDateToUserLocal(ewdDateTime))
                            .replace("{2}", this.newStatusChange);
                } else {
                    message = this.getString("A log with status {0} already exists at {1}. Please wait until the current log has elapsed at least 15 minutes to enter {2}.")
                            .replace("{0}", logWithSameDateTime.status)
                            .replace("{1}", this.convertUtcDateToUserLocal(ewdDateTime))
                            .replace("{2}", this.newStatusChange);
                }
            }

            let resetStatus = () => {
                this.newStatusChange = undefined;
                this.setActiveStatusButton(currentStatus);
            };

            if (message !== "") {
                let dialog = new Dialog(
                    "ewdLog-exists",
                    `<span class='noTranslate'>${ message }</span>`,
                    this.translator,
                    "Attention",
                    [[{
                        id: "clear-ewdDialog",
                        text: "OK",
                        callback: () => {
                            resetStatus();
                            dialog.remove();
                        }
                    }]],
                    {
                        closable: true,
                        isNightMode: this.app.store.getState().data.nightMode,
                        onCancelCallback: () => {
                            resetStatus();
                        }
                    }
                );

                dialog.open().then(() => Promise.resolve());
            } else {
                let currentDevice = getCurrentVehicle()?.id || null;
                let currentDate = getServerDate();
                getStatusData(this.app.api, currentDevice, currentDate, currentDate, "DiagnosticOdometerAdjustmentId").then(result => {
                    if (result) {
                        let odometer = result[0].data;
                        if (!odometer) {
                            // We display a dialog for the user to enter an odometer manually if odometer not available
                            this.manualInputOdometer();
                        } else {
                            this.changeDutyStatus(odometer);
                        }
                    }
                }).catch(() => {
                    // We trigger this in case the network is offline or no vehicle is chosen
                    this.manualInputOdometer();
                });
            }
        } else {
            this.changeDutyStatus();
        }
    }

    setNewLogTime(dateTime: string): void {
        this.dateTimeForNewLog = dateTime;
    }

    getDateTimeForNewLog(): string | undefined {
        return this.dateTimeForNewLog;
    }

    changeDutyStatus(odometer?: number) {
        this.dateTimeForNewLog = getServerDate().toISOString();
        clearTimeout(this.statusChangeTimeout);

        //Change duty status after delay
        this.statusChangeTimeout = setTimeout(() => {
            void this.changeDutyStatusWithNewLog(false, odometer);
        }, constants.HOS.STATUS_CHANGE_DELAY);
    }

    changeDutyStatusWithNewLog(syncLater: boolean, odometer?: number): Promise<void> {
        let previousLog = this.latestLog;
        let currentStatus = previousLog && previousLog.status || undefined;
        let currentVehicle = getCurrentVehicle();
        let ewdDateTime: Date | undefined = this.isEwd ? roundBasedOnCurrentStatus(getServerDate(), this.newStatusChange as THosStatus, currentStatus) : undefined;

        let isNewLogBeforePreviousLog = previousLog && this.dateTimeForNewLog && (previousLog.dateTime > this.dateTimeForNewLog);

        if (!this.newStatusChange || currentStatus === this.newStatusChange || !currentVehicle || isNewLogBeforePreviousLog && !this.model.isEwd) {
            isNewLogBeforePreviousLog && currentStatus && this.setActiveStatusButton(currentStatus);
            return Promise.resolve();
        }

        let newLog = new DutyStatusLog({
            id: idSerializer.get(),
            dateTime: ewdDateTime ? ewdDateTime.toISOString() : this.dateTimeForNewLog ? this.dateTimeForNewLog : getServerDate().toISOString(),
            status: this.newStatusChange,
            device: { id: currentVehicle.id },
            driver: { id: this.currentUser.id },
            coDrivers: this.app.userService.getCoDrivers(this.currentUser.name),
            origin: "Manual"
        });

        if (odometer) {
            newLog.odometer = odometer;
        }
        function isLocationPermissionDenied(): PromiseLike<boolean> {
            if (!("permissions" in navigator)) {
                return Promise.resolve(false);
            }
            try {
                return navigator.permissions.query({ name: "geolocation" as PermissionName })
                    .then(status => status.state === "denied")
                    .catch(() => false);
            } catch {
                return Promise.resolve(false);
            }
        }

        // Reset new status change
        let status = this.newStatusChange;
        this.newStatusChange = undefined;
        this.setLatestLog(new DutyStatusLog(newLog));

        return this.sync.dutyStatusLogs.addItem(newLog, true)
            .then(() => {
                let currentDate = getServerDate().getTime();
                let latestLog = this.app.dutyStatusLogService.getLatestStatusLog();
                if (this.model.isEwd && ewdDateTime) {
                    if (!constants.HOS.DISABLE_STATUS_TOAST) {
                        toastr.info(this.getStatusChangeMessage(newLog.status, this.convertUtcDateToUserLocal(ewdDateTime)), undefined, undefined, {
                            positionClass: "toast-bottom-center",
                            timeOut: constants.HOS.DUTY_STATUS_TOAST_TIMEOUT,
                            origin: ToastOrigins.HOS_STATUS_CHANGE,
                            isImportant: false
                        });
                    }

                    return !isNoVehicle() ? Promise.resolve(undefined) : getCurrentLocationUsingDeviceLocationAndGps(this.app.api, this.app.store);
                }
                if (latestLog && newLog.id === latestLog.id && Math.abs(currentDate - new Date(newLog.dateTime).getTime()) < constants.HOS.TOAST_MESSAGE_DELAY_MAX) {
                    let toastLinks: IToastLink[] = this.getWorkdayToastLink(status);
                    toastLinks.push({
                        linkText: this.getString("Change time or annotate"),
                        linkId: "add-annotation-toast",
                        linkCallback: () => {
                            let violations = this.ruleResult ? this.ruleResult.violations : [];
                            let logId = newLog.id;
                            let filteredViolations: IHosViolationSlim[] = violations
                                .filter(vio => vio.logId === logId)
                                .map((vio: any) => ({ start: new Date(vio.fromDate).toISOString(), reason: populateViolationReason(vio) }));
                                this.app.router.navigate(`hos/tabs/logs/view,${ rison.encode({ id: logId, violations: filteredViolations, fromMain: true }) }`, true);
                        }
                    });

                    if (!constants.HOS.DISABLE_STATUS_TOAST) {
                        toastr.info(this.getStatusChangeMessage(newLog.status), undefined, toastLinks, {
                            positionClass: "toast-bottom-center",
                            timeOut: constants.HOS.DUTY_STATUS_TOAST_TIMEOUT,
                            origin: ToastOrigins.HOS_STATUS_CHANGE,
                            isImportant: false
                        });
                    }
                }

                // Handle location for NoVehicle scenario after log is added
                if (!isNoVehicle()) {
                    return Promise.resolve(undefined);
                }
                // If we already have a location, we're done
                if (newLog.location) {
                    return Promise.resolve(undefined);
                }

                // Check permission state again and try to get location
                return isLocationPermissionDenied()
                    .then(denied => {
                        if (denied) {
                            // Permission denied: prompt for manual entry
                            return this.promptManualLocationForLog(newLog).then(() => {
                                if (!newLog.location) {
                                    // Only create MissingElementCompliance if permission was denied AND user didn't provide location
                                    this.createMissingElementComplianceLog(newLog);
                                }
                            });
                        }

                        // Try to get location via GPS
                        return this.getAndPersistLocation(newLog);
                    });
            })
            .then(() => {
                // Invalidate Exemption log if necessary
                let validRuleSet = this.hosUtils.getValidRuleSet(this.hosUtils.getLatestHosRuleSetIdShortened(true));
                let ruleset = this.hosUtils.getRuleSets()[validRuleSet];
                let errLog = this.app.dutyStatusLogService.getLatestLog(this.app.dutyStatusLogService.getHOSLogs(), newLog, (hosLog: DutyStatusLog) => hosLog.isNormalLogIncludingControlLogs());
                let workdayOffDutyStatuses = ruleset.config.workday?.consecutiveOffCountIncludesWt
                    ? offDutyStatuses
                    : offDutyStatuses.filter(s => s !== "WT");

                // If exemption requirement rule is broken
                if (errLog?.status === "ExemptionReducedRest") {
                    let offLog = this.app.dutyStatusLogService.getLatestLog(this.app.dutyStatusLogService.getHOSLogs(), errLog, (hosLog: DutyStatusLog) => hosLog.isNormalLogIncludingControlLogs());
                    if (ruleset.config.workday?.exemptionReducedRest?.offDutyMinimum &&
                        onDutyStatuses.indexOf(newLog.status) !== -1 &&
                        offLog && workdayOffDutyStatuses.indexOf(offLog.status) !== -1 &&
                        Math.abs(new Date(newLog.dateTime).getTime() - new Date(offLog.dateTime).getTime()) < ruleset.config.workday.exemptionReducedRest.offDutyMinimum) {
                        errLog.state = "Inactive";
                        newLog.addAnnotation(this.hosUtils.getNewAnnotation("Invalidated Reduced Rest Exemption.", this.currentUser));
                        return this.sync.dutyStatusLogs.setItem(errLog, true).then(() => this.sync.dutyStatusLogs.setItem(newLog, true));
                    }
                }
                return Promise.resolve();
            })
            .then(() => {
                if (!syncLater) {
                    return this.sync.synchronize(false, null, [SyncType.HOS]);
                }
                return Promise.resolve();
            })
            .then(() => {
                // Update collection, reprocess, and render
                this.hosUtils.process();
            })
            .catch(e => {
                this.unsetLatestLog(previousLog);
                currentStatus && this.setActiveStatusButton(currentStatus);

                e && handleApi(e);
            });
    }

    userMenuOpened() {
        // Clear timeout and add the pending status change (if applicable)
        clearTimeout(this.statusChangeTimeout);
        this.newStatusChange && this.changeDutyStatusWithNewLog(false);
    }

    remove() {
        // Navigating away from the page locks the status in, but does not re-render the page
        this.stopListening(dispatcher);

        // Clear timeout and add the pending status change (if applicable)
        clearTimeout(this.statusChangeTimeout);
        this.newStatusChange && this.changeDutyStatusWithNewLog(false);
        // Flush any pending split sleeper sync before navigating away, matching the
        // statusChangeTimeout flush-then-clear pattern above.
        this.menu && this.menu.remove();
        this.buttonsBar && this.buttonsBar.hide();
        delete this.buttonsBar;

        window.removeEventListener("resize", this.onResizeBind);

        super.remove();
        return this;
    }

    navigateLogList() {
        this.app.router.navigate("hos/tabs/logs/logs", true);
    }

    availMoreInfo(e) {
        let clickedBtn = e && e.currentTarget && e.currentTarget.getAttribute("data-id");

        if (clickedBtn) {
            if (clickedBtn === "exemptions") {
                this.model.showingExemptions = !this.model.showingExemptions;
                this.model.recapInfo = this.model.recapInfo ? !this.model.recapInfo : this.model.recapInfo;
            } else {
                this.model.recapInfo = !this.model.recapInfo;
                this.model.showingExemptions = this.model.showingExemptions ? !this.model.showingExemptions : this.model.showingExemptions;
            }

            this.renderImpl(true);
        }
    }

    applyExemption(type, event?: Event, force = false, annotations: IAnnotation[] = []): Promise<DutyStatusLog | undefined> {
        if (this.model[`${ type }Valid`] === true || force) {
            return this.changeExemptionStatus(type, event, false, force, annotations).then(log => {
                this.hosUtils.process();
                return new DutyStatusLog(log);
            });
        }

        return Promise.resolve();
    }

    applyAdverseWeather(e: Event) {
        if (this.model.AdverseWeatherValid === true && !this.model.isAdverseWeatherApplied) {
            this.applySituation("AdverseWeather", e);
         }
    }

    removeAdverseWeatherExemption = () => {
        let statusLogs = this.app.dutyStatusLogService.getHOSLogs();
        let lastAdcLog = this.app.dutyStatusLogService.getLatestLog(statusLogs, undefined, (hosLog: DutyStatusLog) => hosLog.status === "AdverseWeather");
        if (lastAdcLog && lastAdcLog.status === "AdverseWeather") {
            lastAdcLog.state = "Inactive";
            void this.sync.dutyStatusLogs.setItem(lastAdcLog);
        }
        return Promise.resolve().then(() => {
            let prevStatusLog = this.app.dutyStatusLogService.getLatestStatusLog();
            if (prevStatusLog) {
                prevStatusLog.addAnnotation(this.hosUtils.getNewAnnotation("Declaration of Adverse Driving Conditions removed by driver.", this.currentUser));
                return this.sync.dutyStatusLogs.setItem(jsonClone(prevStatusLog));
            }
            return Promise.resolve();
        })
        .catch(handleApi);
    };

    removeAdverseWeather() {
        if (this.model.isAdverseWeatherApplied) {
            let dialogDescription = _.template(situationDialogHTML);
            let status = "AdverseWeather";
            let statusDesc = "Adverse Weather Remove";
            let equivalentStatus = "";
            let message1 = "";
            let message2 = "Remove extra availability granted by declaration of Adverse Driving Conditions.";
            let isAnnotationRequired = undefined;
            let description = dialogDescription({
                status,
                statusDesc,
                equivalentStatus,
                message1,
                message2,
                isAnnotationRequired,
                showAutoComplete: false
            });
            createSituationDialog(this.app.store, this.removeAdverseWeatherExemption, description, status, this.translator, "remove");
        }
    }

    applyBigDay() {
        if (this.model.Exemption16HValid) {
            let validRuleSet = this.hosUtils.getValidRuleSet(this.hosUtils.getLatestHosRuleSetIdShortened(true));
            let ruleset = this.hosUtils.getRuleSets()[validRuleSet];
            let cycleLength = ruleset.config.cycle && ruleset.config.cycle.cycleDays || 0;
            let maxPerCycle = ruleset.config.bigDayMaxPerCycle || 1;
            let msg = this.getString("The number of times the 16-hour exemption can be used: {0}. This can be used every {1} days and is not extended by split sleeper breaks.")
                .replace("{0}", `${ maxPerCycle.toString() }`)
                .replace("{1}", `${ cycleLength.toString() }`);


            createBigDayDialog(
                this.app.store,
                () => {
                    return this.applyExemption("Exemption16H")
                        .then(newStatusLog => {
                            if (newStatusLog) {
                                let annotation = this.getString("16h exemption is applied at {0}").replace("{0}", `${ formatLocalDate(newStatusLog.dateTime) }`);
                                return this.addExemptionAnnotation(newStatusLog, annotation);
                            } else {
                                return Promise.resolve();
                            }
                        });
                },
                this.translator,
                msg
            );
        }
    }

    applyWaitTime(e) {
        if (this.model.WTValid === true) {
            void this.applyExemption("WT", e)
                .then((newStatusLog?: DutyStatusLog) => {
                    if (newStatusLog) {
                        let annotation = this.getString("Wait time applied at {0}.").replace("{0}", `${ formatLocalDate(newStatusLog.dateTime) }`);
                        return this.addExemptionAnnotation(newStatusLog, annotation);
                    } else {
                        return Promise.resolve();
                    }
                });

        } else if (this.model.WTValid === null) {
            let target = <HTMLElement>e.currentTarget;
            target.setAttribute("disabled", "disabled");

            void this.changeExemptionStatus("OFF", e, true);
        }
    }

    applyReducedRest(e) {
        if (this.model.ExemptionReducedRestValid) {
            this.applySituation("ExemptionReducedRest", e);
        }
    }

    applyOffDeferral() {
        createFirstDayDialog.call(this, this.app.store, duration => {
            let currentVehicle = <IIdEntity>getCurrentVehicle();
            let currentTime = getServerDate();

            let log = new DutyStatusLog({
                id: idSerializer.get(),
                dateTime: currentTime.toISOString(),
                status: "ExemptionOffDutyDeferral",
                device: { id: currentVehicle.id },
                driver: { id: this.currentUser.id },
                coDrivers: this.app.userService.getCoDrivers(this.currentUser.name),
                origin: "Manual" as THosOrigin,
                deferralStatus: "DayOne",
                deferralMinutes: duration
            });

            return this.sync.dutyStatusLogs.addItem(log)
                .then(() => {
                    this.cachedLogs.push(new DutyStatusLog(log));
                })
                .catch(handleApi);
        }, this.translator);
    }

    applyYardMove(e: Event) {
        if (this.model.YMValid === true) {
            this.applySituation("YM");
        } else if (this.model.YMValid === null) {
            void this.changeExemptionStatus("ON", e, true);
        }
    }

    applyPersonalConveyance(e: Event) {
        if (this.model.PCValid === true) {
            this.applySituation("PC");
        } else if (this.model.PCValid === null) {
            void this.changeExemptionStatus("OFF", e, true);
        }
    }

    applyWorkExemption(e: Event) {
        // Check if it's okay to enter/leave work exemption before we even try.
        let ewdDateTime = roundBasedOnCurrentStatus(getServerDate(), "WorkExemption", this.latestLog?.status);
        let isNewLogBeforePreviousLog = this.latestLog && this.dateTimeForNewLog && (this.latestLog.dateTime > this.dateTimeForNewLog);
        let logWithSameDateTime = this.app.dutyStatusLogService.getLogWithIdenticalDateTime(new Date(ewdDateTime.toISOString()));
        let message = "";

        if (logWithSameDateTime) {
            message = this.getString("A log with status {0} already exists at {1}. Please wait until the current log has elapsed at least 15 minutes to enter {2}.")
                .replace("{0}", logWithSameDateTime.status)
                .replace("{1}", this.convertUtcDateToUserLocal(ewdDateTime))
                .replace("{2}", this.getString("Work Exemption"));
        } else if (isNewLogBeforePreviousLog && this.latestLog) {
            message = this.getString("A log with status {0} already exists at {1}. Please wait until the future log has elapsed at least 15 minutes to enter {2}.")
                .replace("{0}", this.latestLog?.status)
                .replace("{1}", this.convertUtcDateToUserLocal(ewdDateTime))
                .replace("{2}", this.getString("Work Exemption"));
        }

        if (message !== "" && this.model.WorkExemptionValid === true) {
            let dialog = new Dialog(
                "ewdLog-exists",
                message,
                this.translator,
                "Attention",
                [[{
                    id: "clear-ewdDialog",
                    text: "OK",
                    callback: () => {
                        this.newStatusChange = undefined; // clear the pending status change
                        dialog.remove();
                    }
                }]],
                {
                    closable: true,
                    isNightMode: this.app.store.getState().data.nightMode
                }
            );

            dialog.open().then(() => Promise.resolve());
        } else {
            if (this.model.WorkExemptionValid === true) {
                this.applySituation("WorkExemption", e);
            } else if (this.model.WorkExemptionValid === null) {
                void this.changeExemptionStatus("Rest", e, true);
            }
        }
    }

    applyExemptedHOS(e: Event) {
        if (this.model.PC_ExemptedValid === true) {
            this.applySituation("PC_Exempted", this.model.workflow ? e : undefined);
        } else if (this.model.PC_ExemptedValid === null) {
            void this.changeExemptionStatus("OFF", e, true);
        }
    }

    applyRailroadExemption(e: Event) {
        if (this.model.RailroadExemptionValid) {
            this.applySituation("RailroadExemption", e);
        }
    }

    startEmergencyResponseExemption(e: Event) {
        const status: THosStatus = "EmergencyResponseExemptionEnabled";
        const description = _.template(situationDialogHTML)({
            status,
            statusDesc: "",
            equivalentStatus: "",
            message1: this.getString("This exemption extends your available hours through the rest of the day. The system won't record violations while it's active."),
            message2: this.getString("The exemption ends automatically at the end of your day. You can end it earlier."),
            isAnnotationRequired: true,
            annotationTitle: this.getString("Reason for exemption (such as a job or dispatch number)"),
            showAutoComplete: true
        });
        this.autoCompletionInput = new AutoCompletionInput({ app: this.app, action: status, maxSize: 60, value: "" });

        const startCallback = () => {
            const annotationText = this.getAnnotationText();
            if (!isExemptionAnnotationLengthValid(annotationText)) {
                return Promise.reject();
            }
            this.autoCompletionInput?.cacheHint(annotationText);
            return this.addEmergencyResponseExemptionLog(status, e, annotationText, "Exemption applied");
        };

        createSituationDialog(this.app.store, startCallback, description, status, this.translator, "startEmergencyResponse", this.autoCompletionInput);
    }

    endEmergencyResponseExemption(e: Event) {
        const status: THosStatus = "EmergencyResponseExemptionDisabled";
        const description = _.template(situationDialogHTML)({
            status,
            statusDesc: "",
            equivalentStatus: "",
            message1: this.getString("Your available hours will return to normal immediately. You may already be out of hours."),
            message2: "",
            isAnnotationRequired: false,
            annotationTitle: "Optional:",
            showAutoComplete: true
        });
        this.autoCompletionInput = new AutoCompletionInput({ app: this.app, action: status, maxSize: 60, value: "" });

        const endCallback = () => this.addEmergencyResponseExemptionLog(status, e, this.getAnnotationText(), "Exemption ended");

        createSituationDialog(this.app.store, endCallback, description, status, this.translator, "endEmergencyResponse", this.autoCompletionInput);
    }

    applyAction() {
        let status = this.latestLog ? this.latestLog.status : undefined;
        if (status === "PC") {
            createPersonalConveyanceStatusChangeDialog(
                this.app.store,
                () => this.applyExemption("PC", undefined, true).catch(handleApi),
                () => this.changeExemptionStatus("OFF", undefined, true).catch(handleApi),
                this.translator
            );
        }

        return;
    }

    addExemptionAnnotation(newExemptionLog: DutyStatusLog, annotation: string) {
        let statusLogs = this.app.dutyStatusLogService.getHOSLogs().filter(hosLog => hosLog.isMainLogPageLog(this.app.userService.getCurrentUser()));
        let prevStatusLog = this.app.dutyStatusLogService.getLatestLog(statusLogs, newExemptionLog);
        let logToEdit = prevStatusLog ? prevStatusLog : newExemptionLog;
        logToEdit.addAnnotation(this.hosUtils.getNewAnnotation(annotation, this.currentUser, newExemptionLog.dateTime));
        return this.sync.dutyStatusLogs.setItem(jsonClone(logToEdit));
    }

    /**
     * Given a string status, creates and returns a new DutyStatusLog object
     */
    changeExemptionStatus(
        status: THosStatus,
        event?: Event,
        isEndingSituationalStatus = false,
        ignoreAdditionalStatus = false,
        annotations: IAnnotation[] = [],
        device?: IIdEntity,
        origin?: THosOrigin
    ): Promise<DutyStatusLog> {
        let currentVehicle = device || getCurrentVehicle();
        let currentTime = getServerDate();
        let ewdDateTime: Date | undefined;

        if (!currentVehicle) {
            return Promise.resolve();
        }

        if (this.model.isEwd) {
            ewdDateTime = roundBasedOnCurrentStatus(getServerDate(), status, this.latestLog?.status);
        }

        let log = new DutyStatusLog({
            id: idSerializer.get(),
            dateTime: ewdDateTime ? ewdDateTime.toISOString() : currentTime.toISOString(),
            status,
            device: { id: currentVehicle.id },
            driver: { id: this.currentUser.id },
            coDrivers: this.app.userService.getCoDrivers(this.currentUser.name),
            origin: origin || "Manual"
        });

        if (annotations.length > 0) {
            log.annotations = annotations;
        }
        let previousLog = this.latestLog;
        this.setLatestLog(new DutyStatusLog(log));
        this.renderImpl();

        // Disable button while applying change
        if (event) {
            let target = <HTMLElement>event.currentTarget || event.target;
            target && target.setAttribute("disabled", "disabled");
        }

        return (device || !isNoVehicle() ? Promise.resolve(undefined) : getCurrentLocationUsingDeviceLocationAndGps(this.app.api, this.app.store))
            .then(location => {
                log.location = location || undefined;
                if (status === "YM" || status === "WT" || (status === "PC" && !ignoreAdditionalStatus) || (status === "PC_Exempted" && !ignoreAdditionalStatus) || isEndingSituationalStatus) {
                    const additionalSituationalLogs = this.getAdditionalSituationalLog(log, currentTime, isEndingSituationalStatus, previousLog);
                    if (additionalSituationalLogs.length > 0) {
                        return Promise.all(additionalSituationalLogs.map(newLog => this.sync.dutyStatusLogs.addItem(newLog, true)))
                            .then(() => {
                                additionalSituationalLogs.forEach(newLog => {
                                    DISPLAY_STATUSES.indexOf(newLog.status) !== -1 && this.cachedLogs.push(new DutyStatusLog(newLog));
                                });
                            });
                    }
                }
                return Promise.resolve();
            })
            .then(() => this.sync.dutyStatusLogs.addItem(log, true))
            .then(() => {
                this.sync.synchronize(false, null, [SyncType.HOS]).catch(handleApi);
                if (this.model.workflow) {
                    dispatcher.trigger(DispatcherEvents.CompleteWorkflowStep, false);
                } else {
                    this.cachedLogs.push(new DutyStatusLog(log));
                }
                return log;
            })
            .catch(e => {
                this.unsetLatestLog(previousLog, true);
                e && handleApi(e);
                throw e;
            });
    }

    getAdditionalSituationalLog(log: DutyStatusLog, currentTime: Date, isEndingSituationalStatus: boolean, previousLog: DutyStatusLog | null): DutyStatusLog[] {
        const additionalSituationalLog = extend(true, {}, log, { id: idSerializer.get(), dateTime: new Date(currentTime.getTime() - 10).toISOString() });
        const newLogs = [additionalSituationalLog];
        const firstAnnotation = additionalSituationalLog.annotations?.length ? additionalSituationalLog.annotations[0] : undefined;
        if (firstAnnotation) {
            firstAnnotation.id = idSerializer.get();
        }

        // If YM, we should first go into ON first
        // If PC or WT or PC_Exempted, we should go into OFF first
        // If we're ending YM or PC or PC_Exempted, add SituatationalDrivingClear
        if (isEndingSituationalStatus) {
            additionalSituationalLog.status = "SituationalDrivingClear";
            if (previousLog?.isSituationalDrivingStatus()
                && previousLog.status !== "WT" && this.app.dutyStatusLogService.getLastLogIfDrivingWhileInExemption(this.currentUser.id, previousLog, currentTime.toISOString())) {
                const drivingStoppedWhileInExemptionLog = extend(
                    true,
                    {},
                    additionalSituationalLog,
                    { id: idSerializer.get(), coDrivers: [], origin: "Automatic", dateTime: new Date(currentTime.getTime() - 20).toISOString(), status: "DrivingStoppedWhileInExemption" }
                );
                drivingStoppedWhileInExemptionLog.annotations = undefined;
                newLogs.push(drivingStoppedWhileInExemptionLog);
            }
        } else {
            if (firstAnnotation) {
                firstAnnotation.comment = `${ log.status } ${ this.getString("Enabled") }: ${ firstAnnotation.comment }`.substring(0, 60);
            }
            additionalSituationalLog.status = log.status === "YM" ? "ON" : "OFF";
        }
        return newLogs;
    }

    applySituation(status: THosStatus, event?: Event) {
        let statusDesc;
        let equivalentStatus;
        let message1 = "";
        let message2 = "";
        // Should not ask for annotation when isAnnotationRequired is undefined
        // Annotation is optional when isAnnotationRequired is false
        let isAnnotationRequired: boolean | undefined = true;
        let dialogActionType: TSituationActionType = "apply";
        let annotationTitle = "";

        annotationTitle = this.getString("An annotation is required:");

        message1 = this.getString("Are you sure you want to apply the {0} exemption?").replace("{0}", `${ htmlEscape(statusDesc) }`);

        switch (status) {
            case "PC":
                statusDesc = this.getString("personal conveyance");
                equivalentStatus = "OFF";
                message1 = this.getString("You can drive your truck off-duty when relieved from work duties.");
                message2 = this.getString(
                    "Note: Your PC Status doesn't end when the ignition is off. When you restart the vehicle, you must continue or end the status, or your status will switch to driving."
                );
                annotationTitle = this.getString("Enter reason for exemption:");
                dialogActionType = "applyPC";
                break;
            case "PC_Exempted":
                statusDesc = this.model.customExemptHOSName;
                equivalentStatus = "OFF";
                message1 = this.getString(
                    "This relieves you from driving hour rules for today. It ends automatically with your workday, or you may end it earlier."
                );
                annotationTitle = this.getString("Enter reason for exemption:");
                dialogActionType = "applyExemption";
                break;
            case "YM":
                statusDesc = this.getString("yard move");
                equivalentStatus = "ON";
                message2 = this.getString("Your duty status will be set to {0} for the duration of this exemption.").replace("{0}", `${ equivalentStatus }`);
                break;
            case "AdverseWeather":
                statusDesc = this.getString("Adverse driving conditions");
                message1 = this.getString(
                    "This exemption applies to weather hazards (snow, ice, sleet, fog, or other bad weather) and unusual road conditions. These conditions were unforeseeable at the start of your shift, after your last break, or to your carrier before dispatch."
                );
                dialogActionType = "applyADC";
                annotationTitle = this.getString("Enter reason for exemption:");
                break;
            case "WorkExemption":
                statusDesc = this.getString("Work Exemption");
                equivalentStatus = "Work Exemption";
                break;
            case "RailroadExemption":
                statusDesc = this.getString("Railroad Exemption");
                isAnnotationRequired = false;
                annotationTitle = "Optional:";
                break;
            case "ExemptionReducedRest":
                statusDesc = this.getString("Reduced Rest Exemption");
                message1 = this.ruleResult?.currentDutyStatus === "OFF"
                    ? this.getString("Add any reduction in rest to your next shift reset.")
                    : this.getString("Number of additional off-duty hours you are required to take for your next shift reset: {0}")
                        .replace(
                            "{0}",
                            (Math.round((this.ruleResult?.availability.exemptionReducedRest?.restAmountToBeDeferred || 0) / HOURS * 100) / 100).toString()
                        ); // Round to 2 decimal places
                message2 =  "";
                isAnnotationRequired = undefined;
                dialogActionType = "applyERR";
                break;
            default:
                break;
        }

        let dialogDescription = _.template(situationDialogHTML);
        let description = dialogDescription({
            status,
            statusDesc,
            equivalentStatus,
            message1,
            message2,
            isAnnotationRequired,
            annotationTitle,
            showAutoComplete: true
        });

        this.autoCompletionInput = new AutoCompletionInput({
                 app: this.app,
                 action: status,
                 maxSize: 60,
                 value: ""
             });

        let applyCallback = () => {
            let exemptionAnnotation = isAnnotationRequired !== undefined
                ? this.getAnnotationText()
                : "";
            let annotation = this.hosUtils.getNewAnnotation(exemptionAnnotation, this.currentUser);

            let showToast = () => {
                if (!constants.HOS.DISABLE_STATUS_TOAST) {
                    toastr.info(this.getString("Exemption applied"), undefined, undefined, {
                        positionClass: "toast-bottom-center",
                        timeOut: constants.HOS.TOAST_MESSAGE_TIMEOUT,
                        origin: ToastOrigins.HOS_STATUS_CHANGE,
                        isImportant: false
                    });
                }
            };

            let isAnnotationLengthValid = () => {
                if (isExemptionAnnotationLengthValid(exemptionAnnotation)) {
                    this.autoCompletionInput && this.autoCompletionInput.cacheHint(exemptionAnnotation);
                    return true;
                }
                return false;
            };

            if (status === "AdverseWeather" || status === "RailroadExemption") {
                if (status === "AdverseWeather" && !isAnnotationLengthValid()) {
                    return Promise.resolve();
                }
                return this.applyExemption(status, event)
                    .then((newStatusLog) => {
                        if (newStatusLog) {
                            let annotationComment = annotation.comment ? ` - ${ annotation.comment }` : "";
                            let statusString = status === "AdverseWeather"
                                ? "Adverse driving conditions applied at {0}"
                                : "Railroad exemption applied at {0}.";

                            return this.addExemptionAnnotation(
                                newStatusLog,
                                this.getString(statusString).replace("{0}", `${ formatLocalDate(newStatusLog.dateTime) }`) + `${ annotationComment }`
                            );
                        } else {
                            return Promise.resolve();
                        }
                    }).then(showToast);
            } else if (status === "PC_Exempted") {
                annotation.comment = this.getString(this.strings[1]).replace("{0}", getCustomExemptHOSName(this.app.store.getState().systemSettings)).replace("{1}", annotation.comment);
            }
            if (isAnnotationRequired !== undefined && !isAnnotationLengthValid()) {
                return Promise.reject();
            }

            let annotations = isAnnotationRequired !== undefined ? [annotation] : [];
            return this.applyExemption(status, event, false, annotations).then(showToast)
                .catch(() => Promise.resolve());
        };

        createSituationDialog(this.app.store, applyCallback, description, status, this.translator, dialogActionType, this.autoCompletionInput);
    }

    convertUtcDateToUserLocal(utcDate: Date) {
        return dstCalculator.toLocalDateTime(utcDate).toLocaleString("en-au", { hour12: false, hour: "2-digit", minute: "2-digit"}).replace("24", "00");
    }

    openToolTip() {
        this.openTooltipDialog(
            "adverseDriving-info",
            this.adverseDrivingToolTipTemplate(),
            document.getElementById("adverseDriving-toolTip")
        );
    }

    openAvailabilityToolTip(e: Event) {
        let target = (e.currentTarget as HTMLElement);
        let tooltipText = target.getAttribute("data-tooltip") || "";
        if (!tooltipText) {
            return;
        }

        let content = `<div class="arrow-up-wrapper"><div class="arrow-up" id="arrow-up"></div></div><span class="toolTip-text">${ tooltipText }</span>`;
        this.openTooltipDialog(`${ target.id }-dialog`, content, target);
    }

    // MYG-114925: flipping the toggle is a display-only change — the engine already
    // computed both availability sets, so re-rendering is all that is needed.
    // No server call, no ruleset change (that approach was rejected in MYG-133117).
    private applySplitSleeperToggle(isEnabled: boolean) {
        if (this.currentUser?.id) {
            this.app.store.dispatch(HosDisplayPreferencesActions.setSplitSleeperEnabled({
                userId: this.currentUser.id,
                enabled: isEnabled
            }));
        }
        this.renderImpl();
    }

    private openTooltipDialog(dialogId: string, content: string, targetEl: HTMLElement | null) {
        this.toolTip = new Dialog(
            dialogId,
            content,
            this.translator,
            undefined,
            undefined,
            {
                alignToElement: targetEl ? `#${ targetEl.id }` : "",
                showCloseIcon: true,
                isNightMode: this.app.store.getState().data.nightMode,
                minWidth: 200
            }
        );

        void this.toolTip.open()
            .then(() => {
                let dialog = document.getElementById(dialogId);
                if (dialog) {
                    let offset = (window.innerWidth - dialog.offsetWidth) / 2;
                    dialog.style.left = offset + "px";
                    dialog.classList.add("dialog-box_tooltip");
                }
                let overlay = document.getElementById(`overlay-${ dialogId }`);
                if (overlay) {
                    overlay.style.opacity = "0";
                }
                offsetArrowUp(targetEl, dialogId);
            });
    }

    private getAndPersistLocation(newLog: DutyStatusLog): Promise<unknown> {
        return getCurrentLocationUsingDeviceLocationAndGps(this.app.api, this.app.store)
            .then(foundLocation => {
                if (foundLocation) {
                    newLog.location = foundLocation;
                    return this.sync.dutyStatusLogs.setItem(newLog, true);
                }
                return undefined;
            });
    }

    private onResize() {
        if (this.toolTip?.isOpen()) {
            this.toolTip.remove();
        }
    }

    private checkForCanadaDayTwoPopup(mostRecentLog: DutyStatusLog | null) {
        if (mostRecentLog && onDutyStatuses.indexOf(mostRecentLog.status) !== -1) {
            let currentDay = getCurrentDay(this.hosUtils.getRuleResult()?.daySummaries);
            let needDeferralDayTwoWithMinutes;
            if (!this.app.featureFlagService.hasFeatureFlag(FeatureFlagName.ENABLE_AUTO_CREATE_NONE_DEFERRAL_LOG)) {
                needDeferralDayTwoWithMinutes =
                    currentDay?.deferralInfo?.status === "DayTwo" && currentDay?.deferralInfo?.deferralLogRequired
                        ? timeSpanToMs(currentDay.deferralInfo.time)
                        : undefined;
            } else {
                needDeferralDayTwoWithMinutes =
                    currentDay?.deferralInfo?.requiredDeferralLogStatus === "DayTwo"
                        ? timeSpanToMs(currentDay.deferralInfo.time)
                        : undefined;
            }
            return needDeferralDayTwoWithMinutes;
        }
        return;
    }

    private renderCanadaDayTwoDialog(mostRecentLog: DutyStatusLog | null, mostRecentRuleSet: string) {
        let currentUser = this.app.userService.getCurrentUser();
        const needDeferralDayTwoWithMinutes = currentUser ? this.checkForCanadaDayTwoPopup(mostRecentLog) : undefined;
        if (needDeferralDayTwoWithMinutes !== undefined) {
            let ruleset = this.hosUtils.getRuleSets()[mostRecentRuleSet];
            let offDutyMinimum = ruleset.config && ruleset.config.daily && ruleset.config.daily.offDutyMinimum || 0;
            createSecondDayDialog(this.app.store, () => {
                let currentVehicle = <IIdEntity>getCurrentVehicle();
                let currentDate = getServerDate();
                let log = new DutyStatusLog({
                    id: idSerializer.get(),
                    dateTime: currentDate.toISOString(),
                    status: "ExemptionOffDutyDeferral",
                    device: { id: currentVehicle.id },
                    driver: { id: (currentUser as IUser).id },
                    coDrivers: this.app.userService.getCoDrivers((currentUser as IUser).name),
                    origin: "Manual",
                    deferralStatus: "DayTwo",
                    deferralMinutes: (needDeferralDayTwoWithMinutes || 0) / MINUTES
                });
                return this.sync.dutyStatusLogs.addItem(log).catch(handleApi);
            }, this.app.translationService.getTranslator(), (needDeferralDayTwoWithMinutes + offDutyMinimum) / MINUTES);
        }
    }

    private renderRuleResult(ruleResult: IHosProcessResult) {
        this.model.violations = ruleResult.violations;
        this.model.inViolation = ruleResult.inViolation;
        this.model.availability = this.engineResultToDisplay(ruleResult).availability;
        this.model.ewdAvailability = ruleResult.ewdAvailability;

        this.model.offDeferral = {};
        let currentDay = getCurrentDay(ruleResult.daySummaries);
        if (currentDay && currentDay.deferralInfo) {
            let deferralStatus = currentDay.deferralInfo.status;
            let deferralMinutes = timeSpanToMs(currentDay.deferralInfo.time) / MINUTES;
            if (deferralStatus && deferralMinutes) {
                this.model.offDeferral.deferralStatus = this.getString(deferralStatus === "DayTwo" ? "Day two" : "Day one");
                let deferralMinutesStr = `${ Math.floor(deferralMinutes / 60) }:${ `0${ deferralMinutes % 60 }`.slice(-2) }`;
                this.model.offDeferral.deferralMinutes = this.getString("Off-duty deferred: {0}").replace("{0}", deferralMinutesStr);
            }
        }
    }

    // MYG-114925: the split sleeper toggle only chooses which already-computed
    // availability set the page renders. It never changes the ruleset or calls
    // the server.
    private engineResultToDisplay(engineResult: IHosProcessResult): IHosProcessResult {
        return {
            ...engineResult,
            ...getSplitSleeperAvailability(engineResult, !this.driverHasTurnedSplitSleeperOff())
        };
    }

    private driverHasTurnedSplitSleeperOff(): boolean {
        return this.model.hasSplitSleeper
            && !getSplitSleeperEnabled(
                this.app.store.getState().hosDisplayPreferences,
                this.currentUser?.id
            );
    }

    private convertMsToString(availabilityTime: string | number, useFloor = false) {
        return convertToTimeString(availabilityTime, this.getString("h"), this.getString("{minutes}m").replace("{minutes}", ""), useFloor);
    }

    private setActiveStatusButton(status?: THosStatus) {
        let statusButtonSelector = this.model.isEwd ? "ewd-status-button_active" : "hos-status-button_active";
        let activeButton = document.querySelector(`.${ statusButtonSelector }`);
        activeButton && activeButton.classList.remove(statusButtonSelector);

        if (status) {
            let activebutton = document.querySelector(`button[data-status="${ status }"]`);
            activebutton && activebutton.classList.add(statusButtonSelector);
        }
    }

    private getStatusChangeMessage(status: THosStatus, logTime?: string) {
        let logUser = new User(this.currentUser);
        let statusName = "";

        switch (status) {
            case "D":
                statusName = this.getString("Driving");
                break;
            case "ON":

                statusName = this.getString("On Duty");
                break;
            case "SB":
                statusName = this.getString("in Sleeper Berth");
                break;
            case "OFF":
                statusName = this.getString("Off Duty");
                break;
            case "Work":
                statusName = this.getString("Currently working");
                break;
            case "Rest":
                statusName = this.getString("Currently resting");
                break;
            default:
                break;
        }

        if (!statusName) {
            return "";
        }

        if (!logTime) {
            return this.getString("{0} is now {1}").replace("{0}", logUser.getFullName()).replace("{1}", statusName);
        } else {
            return this.getString("{0} is now {1} at {2}.").replace("{0}", logUser.getFullName()).replace("{1}", statusName).replace("{2}", logTime);
        }
    }

    private createButtonsBar() {
        this.buttonsBar && this.buttonsBar.hide();
        let buttons: IBarButton[] = [{
            title: this.getString("Continue"),
            id: `continue-hos-button`,
            clickHandler: () => dispatcher.trigger(DispatcherEvents.CompleteWorkflowStep, false)
        }];

        if (this.currentUser.isExemptHOSEnabled && this.model.PC_ExemptedValid) {
            buttons = ([{
                title: htmlEscape(getCustomExemptHOSName(this.app.store.getState().systemSettings)),
                id: `exempthos-workflow-button`,
                className: "button_secondary",
                clickHandler: (e) => this.applyExemptedHOS(e)
            }] as IBarButton[]).concat(buttons);
        }
        this.buttonsBar = new ButtonsBar(buttons, { isNightMode: this.app.store.getState().data.nightMode });
    }

    private getAvailabilityWarnings(latestLog: DutyStatusLog | null): Promise<void> {
        return new Promise(resolve => {
            this.model.workflowWarningMsg = null;
            this.model.workflowWarningType = null;
            this.model.canFixLastLog = false;

            if (!this.model.workflow || !latestLog) {
                resolve();
            } else {
                if (latestLog.isOnDutyStatus()) {
                    let violationErrors = this.hosUtils.checkIfInOrNearViolation(this.ruleResult);
                    if (violationErrors.length > 0) {
                        let isInViolation = violationErrors.some(violationError => violationError.timeLeft <= 0);
                        this.model.canFixLastLog = !this.newLogId && !latestLog.isAutomaticDriving();
                        this.model.workflowWarningType = isInViolation ? "In violation" : "Upcoming violation";

                        return Promise.all(violationErrors.map(violationError => violationError.getNoticeBoxMessage(this.translator)))
                            .then(violationMessages => {
                                this.model.workflowWarningMsg = "";
                                violationMessages.forEach(violationMessage => {
                                    this.model.workflowWarningMsg += violationMessage;
                                });
                                resolve();
                            });
                    }
                } else {
                    let breakInterruptionErrors = this.hosUtils.checkIfBreakWillBeInterrupted();
                    if (breakInterruptionErrors.length > 0) {
                        this.model.workflowWarningType = "Violation risk";
                        let interruptError = breakInterruptionErrors[0];
                        return interruptError.getNoticeBoxMessage(this.translator)
                            .then(message => {
                                this.model.workflowWarningMsg = message;
                                resolve();
                            });
                    }
                }
            }
            resolve();
            return;
        });
    }

    private fixLastLog() {
        if (this.model.canFixLastLog) {
            dispatcher.trigger(DispatcherEvents.CompleteWorkflowStep, true);
        }
    }

    private isValidExemption(ruleSetKey: any, isDriverWithVehicle: boolean | null): boolean | null {
        const currentState = this.app.store.getState().mobile;
        if (isInCanada(ruleSetKey) && (!currentState.deviceCommunicating && !currentState.ioxAttached)) {
            return false;
        }

        return isDriverWithVehicle;
    }

    private isDriversSeatUser() {
        let driverSeatUser = this.app.userService.getDriversSeatUser();
        return driverSeatUser && this.app.userService.isDriverUsingUI(driverSeatUser.name);
    }

    private onUserUpdateOrRulesetSync() {
        this.currentUser = this.app.userService.getCurrentUser() as IUser;
        if (this.latestLog) {
            const isPcRevoked = !this.currentUser.isPersonalConveyanceEnabled && this.latestLog.status === "PC";
            const isYmRevoked = !this.currentUser.isYardMoveEnabled && this.latestLog.status === "YM";

            if (isPcRevoked || isYmRevoked) {
                this.unsetLatestLog(
                    this.app.dutyStatusLogService.getLatestLog(this.cachedLogs, this.latestLog)
                );
            }
        }
        this.refreshUserAndRuleset(this.hosUtils.process());
    }

    private ruleCompute(userId: string, ruleResult = this.hosUtils.getRuleResult()) {
        if (this.currentUser && userId === this.currentUser.id && !this.newStatusChange) {
            this.refreshUserAndRuleset(ruleResult);
            this.renderCanadaDayTwoDialog(this.latestLog, this.model.rulesetKey);
        }
        this.createDayNoneDeferralLogs(ruleResult);
    }

    private createDayNoneDeferralLogs(ruleResult?: IHosProcessResult) {
        if (!ruleResult || !this.app.featureFlagService.hasFeatureFlag(FeatureFlagName.ENABLE_AUTO_CREATE_NONE_DEFERRAL_LOG)) {
            return;
        }
        let daysNeedingDayNoneDeferral = ruleResult.daySummaries?.filter(day => day.deferralInfo?.requiredDeferralLogStatus === "None") ?? [];
        if (daysNeedingDayNoneDeferral.length === 0) {
            return;
        }
        let currentVehicle = <IIdEntity>getCurrentVehicle();
        let existingDayNoneDeferralDays = new Set(this.cachedLogs.filter(log => log.status === "ExemptionOffDutyDeferral" && log.deferralStatus === "None").map(log => log.dateTime));
        daysNeedingDayNoneDeferral.forEach(day => {
            let dateTimeString = day.dateTime.toISOString();
            if (existingDayNoneDeferralDays.has(dateTimeString)) {
                return;
            }
            let log = new DutyStatusLog({
                id: idSerializer.get(),
                dateTime: dateTimeString,
                status: "ExemptionOffDutyDeferral",
                device: { id: currentVehicle.id },
                driver: { id: this.currentUser.id },
                coDrivers: this.app.userService.getCoDrivers(this.currentUser.name),
                origin: "Manual",
                deferralStatus: "None",
                deferralMinutes: 0
            });
            this.cachedLogs.push(new DutyStatusLog(log));
            this.sync.dutyStatusLogs.addItem(log).catch(handleApi);
        });
    }

    private refreshUserAndRuleset(ruleResult = this.hosUtils.getRuleResult()) {
        this.currentUser = this.app.userService.getCurrentUser() as IUser;
        this.ruleResult = ruleResult;
        this.renderImpl();
    }

    private manualInputOdometer() {
        let odometerDialog = new Dialog(
            "ewdOdometerDialog",
            this.odometerInputDialogTemplate({ units: this.app.localizerService.getDistanceUnit(true) }),
            this.translator,
            "Enter an Odometer",
            [{
                id: "ewdOdometerOK",
                text: "OK",
                callback: () => {
                    let odometer = (<HTMLInputElement>document.querySelector("#ewdOdometerInput")).value.trim();
                    if (!isValidOdometer(odometer)) {
                        (<HTMLInputElement>document.querySelector("#invalidOdometerInput")).style.display = "block";
                        return;
                    }

                    this.changeDutyStatus(this.app.localizerService.toMetresFromLocalDistance(Number(odometer)));
                    odometerDialog.remove();
                }
            }],
            {
                isNightMode: this.app.store.getState().data.nightMode,
                onCancelCallback: () => {
                    this.newStatusChange = undefined;
                    this.setActiveStatusButton(this.latestLog?.status);
                }
            }
        );
        odometerDialog.open().catch(handleApi);
    }

    /**
     * Determines what the user's current log is. If the user is using EWD/WWD, then we need to figure out what log is currently active,
     * because we have the capacity to create logs in the future
     */
    private getCurrentLog(): DutyStatusLog | null {
        let now = getServerDate().toISOString();
        let logs = this.app.dutyStatusLogService.getHOSLogs(true, undefined, true, true)
                            .filter(log => !log.placeholder && ALL_AUSTRALIAN_LOG_TYPES.indexOf(log.status) !== -1 && log.dateTime <= now);

        return logs[0] || null;
    }

    private getAnnotationText() {
        let annotation = this.autoCompletionInput?.val || "";
        return annotation.replace(/[\r\n|\r|\n]+/, " ").trim();
    }

    // Emergency Response logs are control logs: they change the rules applied, not the driver's duty status
    private addEmergencyResponseExemptionLog(status: THosStatus, event: Event, annotationText: string, toastMessage: string): Promise<void> {
        const annotations = annotationText ? [this.hosUtils.getNewAnnotation(annotationText, this.currentUser)] : [];
        return this.changeExemptionStatus(status, event, false, false, annotations)
            .then(log => {
                if (!log) {
                    return;
                }
                this.hosUtils.process();
                if (!constants.HOS.DISABLE_STATUS_TOAST) {
                    toastr.info(this.getString(toastMessage), undefined, undefined, {
                        positionClass: "toast-bottom-center",
                        timeOut: constants.HOS.TOAST_MESSAGE_TIMEOUT,
                        origin: ToastOrigins.HOS_STATUS_CHANGE,
                        isImportant: false
                    });
                }
            })
            .catch(() => Promise.resolve());
    }

    /**
     * Prompts the driver to manually enter location for a log when no vehicle location is available.
     * If the driver doesn't provide a location, creates a MissingElementCompliance diagnostic log.
     * @param log The DutyStatusLog that needs a location
     * @returns Promise<void>
     */
    private promptManualLocationForLog(log: DutyStatusLog): Promise<void> {
        return new Promise<void>((resolve) => {
            this.openAddressEntryDialog(log, resolve);
        });
    }

    private openAddressEntryDialog(log: DutyStatusLog, resolve: () => void): void {
        let logAddressInputTemplate = _.template(addressDialogTemplate);

        let addressDialog = new Dialog(
            "hos-address-input",
            logAddressInputTemplate({ isAustralia: this.isEwd }),
            this.translator,
            "Enter an address",
            [[{
                id: "hosAddressCancel",
                className: "button_secondary",
                text: "Cancel",
                callback: () => {
                    addressDialog.remove();
                    resolve();
                }
            }, {
                id: "hosAddressOK",
                text: "OK",
                callback: () => {
                    let thisDialog = document.getElementById("hos-address-input");
                    if (!thisDialog) {
                        addressDialog.remove();
                        resolve();
                        return;
                    }

                    this.hideAddressWarning();

                    let street = (<HTMLInputElement>thisDialog.querySelector("#tempaddress-street"))?.value || "";
                    let city = (<HTMLInputElement>thisDialog.querySelector("#tempaddress-city"))?.value || "";
                    let stateProvince = (<HTMLInputElement>thisDialog.querySelector("#tempaddress-state"))?.value || "";
                    let addressCountry = this.isEwd ? "Australia" : ((<HTMLInputElement>thisDialog.querySelector("#tempaddress-country"))?.value || "");

                    let addressValid = this.validateAddressInput(street, city, stateProvince, addressCountry);

                    if (!addressValid) {
                        this.showAddressWarning();
                    } else {
                        this.updateLogWithAddress(log, street, city, stateProvince, addressCountry)
                            .then(() => {
                                addressDialog.remove();
                                resolve();
                            })
                            .catch((e) => {
                                handleApi(e);
                                addressDialog.remove();
                                resolve();
                            });
                    }
                }
            }]],
            {
                isNightMode: this.app.store.getState().data.nightMode
            }
        );

        addressDialog.open().catch(handleApi);
    }

    private validateAddressInput(...addressParts: string[]): boolean {
        let fullAddress = addressParts.join("");
        return (fullAddress.length >= 5 && fullAddress.length <= 60);
    }

    private showAddressWarning(): void {
        let element = document.getElementById("hos-address-warning");
        if (element) {
            element.style.display = "block";
        }
    }

    private hideAddressWarning(): void {
        let element = document.getElementById("hos-address-warning");
        if (element) {
            element.style.display = "none";
        }
    }

    private updateLogWithAddress(
        log: DutyStatusLog,
        street: string,
        city: string,
        stateProvince: string,
        addressCountry: string
    ): Promise<void> {
        let formattedAddress = this.formatAddress(street, city, stateProvince, addressCountry);

        log.location = {
            address: {
                formattedAddress: formattedAddress
            }
        };

        log._address = htmlEscape(formattedAddress);
        log.editDateTime = getServerDate().toISOString();

        return this.sync.dutyStatusLogs.setItem(log, true)
            .then(() => {
                let cachedLogIndex = this.cachedLogs.findIndex(cachedLog => cachedLog.id === log.id);
                if (cachedLogIndex !== -1) {
                    this.cachedLogs[cachedLogIndex] = new DutyStatusLog(log);
                }
            });
    }

    private formatAddress(...addressParts: string[]): string {
        return addressParts.filter(part => !!part).join(", ");
    }

    private createMissingElementComplianceLog(relatedLog: DutyStatusLog): void {
        let diagnosticLog = new DutyStatusLog({
            id: idSerializer.get(),
            dateTime: (relatedLog.getDate() || getServerDate()).toISOString(),
            status: "MissingElementCompliance",
            malfunction: "Diagnostic",
            device: { id: "NoDeviceId" },
            driver: { id: this.currentUser.id },
            origin: "Automatic"
        });

        this.sync.dutyStatusLogs.addItem(diagnosticLog, true).then(() => Promise.resolve(true));
    }
}
